/** Draft faces not yet present in the API response for the current clip. */
export const getPendingDraftFaces = <T extends { id: string }>(apiFaces: T[], draftFaces: T[]): T[] => {
  const apiFaceIds = new Set(apiFaces.map((face) => face.id));

  return draftFaces.filter((draft) => !apiFaceIds.has(draft.id));
};
